module.exports = __webpack_public_path__ + "images/emoji/horse.e7ac547c1621dab04695.png";